import { IndianRupee, TrendingUp, Sun } from "lucide-react";
import { Reveal } from "./Reveal";
import { ABOUT } from "../data/content";

const ICONS = { IndianRupee, TrendingUp, Sun };

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section-container"
      className="py-20 md:py-28 px-4 sm:px-8 lg:px-16 bg-[#EAE0D5]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -top-5 -left-5 h-24 w-24 rounded-2xl border-2 border-[#C15B3D]/40 hidden sm:block" />
              <img
                src={ABOUT.image}
                alt="Happy family enjoying their farmhouse weekend at Aaroh Farms"
                className="relative rounded-2xl shadow-2xl w-full h-[420px] object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#2C5F2D] text-white rounded-2xl px-6 py-5 shadow-xl hidden sm:block">
                <div className="font-serif text-3xl">36</div>
                <div className="text-xs uppercase tracking-widest text-white/80">
                  Plots Only
                </div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#C15B3D] mb-4">
                Welcome to Aaroh Farms
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-[#1F291E]">
                {ABOUT.title}
              </h2>
              <p className="mt-6 text-lg text-[#5C6B5A] leading-relaxed">
                {ABOUT.intro}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-20 items-stretch">
          {ABOUT.pillars.map((p, i) => {
            const Icon = ICONS[p.icon];
            const featured = i === 1;
            return (
              <Reveal key={p.title} delay={i * 0.1} className="h-full">
                <article
                  data-testid={`about-card-${i}`}
                  style={{ animationDelay: `${i * 3}s` }}
                  className={`group relative h-full flex flex-col rounded-3xl p-8 sm:p-10 transition-transform duration-500 ${
                    featured
                      ? "pillar-card-featured bg-[#2C5F2D] hover:-translate-y-2 md:-translate-y-4"
                      : "pillar-card bg-[#F7F3EE] border border-[#D5C8B8] shadow-lg hover:shadow-2xl hover:-translate-y-2"
                  }`}
                >
                  <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-3xl">
                    <span
                      className="pillar-sheen-beam absolute top-0 left-0 h-full w-1/3 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                      style={{ animationDelay: `${i * 2.3}s` }}
                    />
                  </div>
                  <div
                    className={`pillar-icon h-14 w-14 rounded-2xl grid place-items-center mb-7 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3 ${
                      featured ? "bg-[#C15B3D]" : "bg-[#2C5F2D]"
                    }`}
                    style={{ animationDelay: `${i * 0.6}s` }}
                  >
                    <Icon className="h-7 w-7 text-white" strokeWidth={1.8} />
                  </div>
                  <h3
                    className={`font-serif text-2xl leading-snug mb-3 ${
                      featured ? "text-white" : "text-[#1F291E]"
                    }`}
                  >
                    {p.title}
                  </h3>
                  <p
                    className={`font-serif italic text-base mb-6 ${
                      featured ? "text-[#EAC9B8]" : "text-[#C15B3D]"
                    }`}
                  >
                    {p.tagline}
                  </p>
                  <div className="space-y-4 mb-6">
                    {p.body.map((para, j) => (
                      <p
                        key={j}
                        className={`text-[15px] leading-relaxed ${
                          featured ? "text-white/75" : "text-[#5C6B5A]"
                        }`}
                      >
                        {para}
                      </p>
                    ))}
                  </div>
                  <div
                    className={`mt-auto pt-6 border-t ${
                      featured ? "border-white/20" : "border-[#D5C8B8]"
                    }`}
                  >
                    <p
                      className={`font-serif text-lg leading-snug ${
                        featured ? "text-white" : "text-[#2C5F2D]"
                      }`}
                    >
                      {p.closing}
                    </p>
                    <p
                      className={`mt-3 text-[11px] uppercase tracking-[0.18em] font-semibold leading-relaxed ${
                        featured ? "text-[#EAC9B8]" : "text-[#C15B3D]"
                      }`}
                    >
                      {p.punch}
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
